/* Cart count badge on the Shiprocket cart icon, and correct totals in the Shiprocket drawer
   (its app script swaps Subtotal/Total and shows the discount as -₹0). Refreshes after any cart change. */
(function () {
  var icon = document.getElementById('cart-icon-bubble-sr');
  if (!icon) return;
  icon.style.position = 'relative';
  icon.setAttribute('aria-label', 'Cart');
  var badge = document.createElement('span');
  badge.className = 'nv-cart-count';
  badge.setAttribute('aria-hidden', 'true');
  icon.appendChild(badge);

  var cart = null;
  function inr(p) { return '₹' + (p / 100).toFixed(2).replace(/\.00$/, ''); }
  function set(sel, text) {
    document.querySelectorAll(sel).forEach(function (el) { if (el.textContent !== text) el.textContent = text; });
  }
  function fixDrawer() {
    if (!cart) return;
    var before = cart.original_total_price || cart.items_subtotal_price;
    var off = Math.max(0, before - cart.total_price);
    var names = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).filter(Boolean);
    set('.mini-cart-title', 'Your Ritual Bag');
    set('.mini-cart-darwer .item_count', '(' + cart.item_count + ')');
    set('.mini-cart-darwer .sr-sub-total', inr(before));
    set('.mini-cart-darwer .total-price', inr(cart.total_price));
    set('.mini-cart-darwer .discount-code', names.length ? 'Discount (' + names.join(', ') + ')' : 'Discount');
    set('.mini-cart-darwer .sr-discount', '-' + inr(off));
    // Shiprocket can add the discount row more than once: show a single row, and only when there is a discount
    document.querySelectorAll('.mini-cart-darwer .discount_wrapper').forEach(function (el, i) { el.style.display = off && i === 0 ? '' : 'none'; });
    // each line: real quantity instead of "x 1", and no "Default Title" variant label
    document.querySelectorAll('#mini-cart-items > .mini-cart-item').forEach(function (el, i) {
      var it = cart.items[i];
      if (!it) return;
      var unit = el.querySelector('.mini-cart-item-details .mini-cart-item-price');
      var text = inr(Math.round(it.line_price / it.quantity)) + ' × ' + it.quantity;
      if (unit && unit.textContent !== text) unit.textContent = text;
      var variant = el.querySelector('.mini-cart-item-variant');
      if (variant && it.product_has_only_default_variant) variant.style.display = 'none';
    });
  }
  var fixTimer;
  var drawer = document.getElementById('mini-cart-darwer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(fixTimer); fixTimer = setTimeout(fixDrawer, 50); })
      .observe(drawer, { childList: true, subtree: true, characterData: true });
  }
  function render(c) {
    cart = c;
    var n = c.item_count || 0;
    badge.textContent = n > 99 ? '99+' : n;
    badge.hidden = !n;
    icon.setAttribute('aria-label', n ? 'Cart, ' + n + ' item' + (n > 1 ? 's' : '') : 'Cart');
    fixDrawer();
    // nv-cart-drawer.js listens for this to update the rewards bar and upsells
    document.dispatchEvent(new CustomEvent('nv:cart', { detail: c }));
  }
  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 300);
  }
  var isCart = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };

  var f = window.fetch;
  window.fetch = function (input) {
    var p = f.apply(this, arguments);
    if (isCart(input && input.url ? input.url : input)) p.then(refresh, refresh);
    return p;
  };
  var o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isCart(u)) this.addEventListener('loadend', refresh);
    return o.apply(this, arguments);
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  refresh();
})();
